export const UPDATE_DELIVERY_POINT = 'UPDATE_DELIVERY_POINT';
export const UPDATE_GROUP_DELIVERY_DAY = 'UPDATE_GROUP_DELIVERY_DAY';
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
export const UPDATE_POSTAL_CODE = 'UPDATE_POSTAL_CODE';
export const RESET_HOME_DELIVERY = 'RESET_HOME_DELIVERY';
export const UPDATE_STREET_LIST = 'UPDATE_STREET_LIST';
